import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { DataImport } from 'graphql-common';
import { Values } from '@lib/interfaces/form';
import Form from '@lib/components/ReactHookForm/FormContainer';
import { FormRefType } from '@lib/components/ReactHookForm/types';
import { IMPORT_HISTORY_FORM } from '@lib/enums/localStorageKeys';
import ImportFormActions from './ImportFormActions';
import useFormFields from './utils/useFormFields';
import getDefaultValues from './utils/getDefaultValues';

interface ImportFormProps {
  activeImport: DataImport | null | undefined;
  formRef: FormRefType;
  isAssetsAvailable: boolean;
  isLoading?: boolean;
  isSitesAvailable: boolean;
  onResetForm: () => void;
  onShowDataImportErrors: (item?: DataImport) => void;
  onSubmit: (data: Values) => void;
}

function ImportForm({
  activeImport,
  formRef,
  isAssetsAvailable,
  isLoading = false,
  isSitesAvailable,
  onResetForm,
  onShowDataImportErrors,
  onSubmit,
}: ImportFormProps) {
  const { t } = useTranslation();
  const defaultValues = getDefaultValues({
    isAssetsAvailable,
    isSitesAvailable,
  });
  const formFields = useFormFields({
    activeImport,
    isAssetsAvailable,
    isLoading,
    isSitesAvailable,
    onShowDataImportErrors,
    t,
  });
  return (
    <Form
      actionsComponent={ImportFormActions}
      actionsComponentProps={{
        canClear: !!activeImport?.id,
        onClear: onResetForm,
      }}
      defaultValues={defaultValues}
      fields={formFields}
      formId={IMPORT_HISTORY_FORM}
      formRef={formRef}
      loading={isLoading}
      onSubmit={onSubmit}
    />
  );
}

export default memo(ImportForm);
